import React from 'react'
import { Text, TextProps } from '@grupoboticario/flora-react'
import { styled, FloraVariants, forwardRef } from '@grupoboticario/flora-react-system'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'
import {
  ChevronDownIcon,
  ChevronUpDownIcon,
  ChevronUpIcon,
} from '@grupoboticario/flora-react-icons'

const StyledTableHeader = styled('th', {
  padding: '$2 $4',
  variants: {
    noPadding: {
      true: {
        padding: '$0',
        width: '$0',
      },
    },
  },
})

const StyledTableHeaderText = styled(
  (props: TextProps) => <Text size="exceptionsRestrictedRegular" {...props} />,
  {
    textTransform: 'uppercase',
    variants: {
      sortable: {
        true: {
          display: 'flex',
          alignItems: 'center',
          gap: '$2',
          cursor: 'pointer',
        },
      },
      align: {
        left: {
          justifyContent: 'left',
        },
        right: {
          justifyContent: 'right',
        },
        center: {
          justifyContent: 'center',
        },
      },
    },
    defaultVariants: {
      align: 'center',
    },
  },
)

export type TableHeaderProps = HTMLFloraProps<'th'> &
  FloraVariants<typeof StyledTableHeader> & {
    align?: 'center' | 'right' | 'left'
    asChild?: boolean
    order?: 'asc' | 'desc' | 'none'
  }

export const TableHeader = forwardRef<'th', TableHeaderProps>(
  ({ align = 'center', asChild = false, order, children, ...props }, forwardedRef) => {
    return (
      <StyledTableHeader ref={forwardedRef} data-flora="table-header" align={align} {...props}>
        {asChild ? (
          <>{children}</>
        ) : (
          <StyledTableHeaderText sortable={!!order} align={align}>
            {children}
            {order === 'none' && <ChevronUpDownIcon size={16} />}
            {order === 'asc' && <ChevronUpIcon size={16} />}
            {order === 'desc' && <ChevronDownIcon size={16} />}
          </StyledTableHeaderText>
        )}
      </StyledTableHeader>
    )
  },
)
